<button 
  nbButton 
  [status]="color" 
  size="small"
  (click)="updateStatus()"
  (mouseover)="onHover()"
  (mouseout)="onLeave()"
>
  <nb-icon [icon]="icon"></nb-icon>
  Status API: <span style="margin-left: 5px; font-size: 1.25rem;">{{ text }}</span>
</button>